__turbopack_context__.v({
  "body": "Page-module-scss-module__gaNQra__body",
  "description": "Page-module-scss-module__gaNQra__description",
  "header": "Page-module-scss-module__gaNQra__header",
  "main": "Page-module-scss-module__gaNQra__main",
  "navbar": "Page-module-scss-module__gaNQra__navbar",
  "root": "Page-module-scss-module__gaNQra__root",
  "shell": "Page-module-scss-module__gaNQra__shell",
  "title": "Page-module-scss-module__gaNQra__title",
});
